var render = function render(){var _vm=this,_c=_vm._self._c;return _c('task-window-view',{staticClass:"window-task task-from-page bg-white",staticStyle:{"margin":"auto"},attrs:{"id":_vm.$route.params.id,"$router":_vm.$router}})
}
var staticRenderFns = []

export { render, staticRenderFns }